import React from 'react';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import SummaryTabContainer from './SummaryTab';
import rootReducer from '../../../reducers';
var store = createStore(rootReducer);
function SummaryTab(props) {
  return /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(SummaryTabContainer, props));
}
export default SummaryTab;